export const amountPaid = (partialRefund) => (
  parseFloat(partialRefund.ticket.amount_paid ?? partialRefund.max_amount) || 0
);

export const refundedSoFar = (partialRefund) => (
  Math.max(Math.round((amountPaid(partialRefund) - parseFloat(partialRefund.max_amount)) * 100) / 100, 0)
);

export const originalPayment = (refund) => (
  parseFloat(refund.order?.total ?? refund.max_amount) || 0
);
